export default "__VITE_ASSET__153bce5a__"